import { pushVirtualPageView } from "./pushToDatalayer";

const removePathPatterns = /(.*)\/no\/|\/se\/|\/dk\/|\/fi\/|\/de\/|\/es\/|\/com\//gi;
const changeFISVEPattern = /(.*)\/FISVE\//gi;

/***
 * Removes Umbraco Region segment from the path. fi-sv, gets /sv/
 * Turns multiple slashes into one and lower case.
 * Doesn't do anything on external links (starting with http)
 */
export const resolveUrl = (inputPath?: string) => {
  if (!inputPath) {
    return "";
  }

  if (isExternalLink(inputPath)) {
    return inputPath;
  }
  const [pathPart, queryPart] = inputPath.split("?");
  const lowerCasePath = pathPart.toLowerCase();
  const path = turnMultipleSlashesIntoOne(lowerCasePath);

  const result = path.match(changeFISVEPattern)
    ? path.replace(changeFISVEPattern, "/sv/")
    : path.replace(removePathPatterns, "/");

  return queryPart ? `${result}?${queryPart}` : result;
};

function isExternalLink(inputPath: string) {
  return inputPath.match(/^http(s)?:\/\/.*/);
}

export function setQueryStringParameter(name: string | null, value: string | null, deletedParameters?: string[]) {
  const params = new URLSearchParams(window.location.search);

  if (name) {
    params.set(name, value ? value : "");
  }

  if (deletedParameters) {
    deletedParameters.forEach((param) => {
      params.delete(param);
    });
  }
  const newUrl = params.toString()
    ? `${window.location.pathname}?${decodeURIComponent(params.toString())}`
    : window.location.pathname;
  window.history.replaceState({}, "", newUrl);
  pushVirtualPageView(document.title, "spa_navigation");
}

export function buildCustomerServiceUrl(path: any, category: any, subcategory: any) {
  if (!path) {
    return null;
  }
  let url = path.url;
  if (category && category.id) {
    url += `?category=${category.id}`;
    if (subcategory && subcategory.id) {
      url += `&subcategory=${subcategory.id}`;
    }
  }
  return resolveUrl(url);
}

export function turnMultipleSlashesIntoOne(value: string) {
  if (!value) {
    return "";
  }
  return value.replace(/([/]{1,})/g, "/");
}

export const getCountryString = () => {
  const url = window.location.hostname;
  let topLevel = url.split(".")?.pop()?.toLowerCase();

  // For not prod env
  if (topLevel === "net") {
    const match = url.match(/(.*)-/);
    if (match && match[1]) {
      topLevel = match[1].toLowerCase();
    }
  }

  if (topLevel === "fi") {
    if (url.match(/\/SV\//gi)) return "fisve";
  }
  return topLevel;
};

export const stripQueryParametersFromPath = (path: string) => path?.split("?")[0];

export function ensureTrailingSlash(str: string) {
  if (!str.endsWith("/")) {
    return `${str}/`;
  }
  return str;
}
